// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__51fRQ","fullView":"styles_fullView__1EVDx"};